import React, { useContext, useEffect, useState } from "react";
import SelectCustomer from "../../Cart/SelectCustomer";
import CustomerDetails from "./CustomerDetails";
import CustomerAccounts from "./CustomerAccounts";
import { Divider } from "@mui/material";
import { Button } from "../../../../../controls";
import { action, API, controller } from "../../../../../api/api";
import CustomerAlert from "./CustomerAlert";
import { CartContext } from "../../POS";

const CheckoutCustomer = ({ handleSubmitSell, disableDelete = false }) => {
  const { cartData } = useContext(CartContext);
  const [customer, setCustomer] = useState({});
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (cartData && cartData.customerId) {
      API(controller.Customer + action.GetCustomerAccounts).getById(
        cartData.customerId,
        (res) => {
          if (res && res.status === 200 && res.result) {
            res.result.customer && setCustomer({ ...res.result.customer });
          }
        }
      );

      API(controller.CustomerTxn + action.CustomerDue).getById(
        cartData.customerId,
        (res) => {
          res && res.status === 200
            ? setBalance(res.result || 0)
            : console.error("Error: ", res);
        }
      );
    } else setCustomer({});

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData.customerId]);

  return (
    <div className="flex flex-col gap-4  pt-0">
      {cartData.customerId ? (
        <div className="border rounded-[12px]">
          {/* ---- Alert ----*/}
          {balance > 0 && <CustomerAlert />}
          {/* ---- Customer Details ----*/}
          <CustomerDetails {...{ customer, disableDelete }} />
          {/* ---- Accounts ----*/}
          <Divider />
          <CustomerAccounts {...{ balance }} />
        </div>
      ) : (
        <>
          <SelectCustomer
            size="large"
            placeholder="Add a customer to pay with the following options:"
          />
        </>
      )}

      {/* Submit Action */}
      {handleSubmitSell && (
        <div className="grid grid-cols-3 gap-1 md:gap-3 flex-wrap">
          {(!cartData.id || cartData.type === 2) && (
            <Button
              onClick={() => handleSubmitSell("", 1, 2)}
              disabled={!cartData.customerId}
              variant="outlined"
              className="w-full !text-[14px] !p-[10px] md:!text-[16px] !uppercase"
            >
              Layby
            </Button>
          )}
          {/* <Button
          disabled={!cartData.customerId}
          variant="outlined"
          className="w-full !text-[14px] !p-[10px] md:!text-[16px] !uppercase"
        >
          Store credit
        </Button> */}
          {(!cartData.id || cartData.type === 1) && (
            <Button
              onClick={() => handleSubmitSell("", 1, 1)}
              disabled={!cartData.customerId}
              variant="outlined"
              className="w-full !text-[14px] !p-[10px] md:!text-[16px] !uppercase"
            >
              On Account
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default CheckoutCustomer;
